<template>
  <div :class="$style.guestCheckoutWelcomeModal">
    <div
      :class="$style.preText"
      v-text="$awt('aw.guest_checkout_welcome.pre_advantage_text')"
    />
    <div :class="$style.advantages">
      <lv-icon
        name="auchan-logo"
        :size="56"
        :class="$style.auchanLogo"
      />
      <ul :class="['ulReset', $style.advantageList]">
        <li
          v-for="ch in 'abcd'"
          :key="ch"
          :class="$style.advantageBox"
        >
          <div :class="$style.advantageIcon">
            <lv-icon
              :name="{
                a: 'flash-24',
                b: 'refresh-double-24',
                c: 'add-partner-24',
                d: 'shopping-cart-24',
              }[ch]"
              :size="24"
            />
          </div>
          <div v-text="$awt(`aw.guest_checkout_welcome.advantage.${ch}`)" />
        </li>
      </ul>
    </div>
    <div
      :class="$style.postText"
      v-text="$awt('aw.guest_checkout_welcome.post_advantage_text')"
    />
  </div>
</template>
<script setup>
  import { LvIcon } from '~~/common/components/loginet-vue-shop/index';
</script>
<style module lang="scss" rel="stylesheet/scss">
.guestCheckoutWelcomeModal {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  display: flex;
  flex-direction: column;

  @include desktop-small(min) {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }
}

.advantages {
  display: flex;
  flex-direction: column;
  padding-top: 12px;
}

.advantageList {
  --guestCheckoutWelcomeModalGridCount: 2;
  display: grid;
  grid-template-columns: repeat(var(--guestCheckoutWelcomeModalGridCount), 1fr);
  gap: 8px;

  @include tablet(min) {
    gap: 20px;
  }

  @include desktop-medium(min) {
    --guestCheckoutWelcomeModalGridCount: 4;
  }
}

.advantageBox {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 24px;
  border-radius: 16px;
  background: $color-white;
  gap: 24px;

  &:first-child {
    @include mobile(max) {
      gap: 12px;
    }
  }

  @include tablet(min) {
    @include desktop-small(max) {
      align-items: start;
      flex-direction: row;
      text-align: left;
    }
  }
}

.advantageIcon {
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  width: 48px;
  height: 40px;
  margin-bottom: 8px;
  color: $color-white;
  border-radius: 8px;
  background: $color-strawberry-500;

  &::after {
    position: absolute;
    bottom: 0;
    display: block;
    width: 0;
    height: 0;
    content: "";
    border-width: 8px 6px 0;
    border-style: solid;
    border-color: $color-strawberry-500 transparent transparent;
    translate: 0 100%;
  }
}

.preText,
.postText {
  font-size: 14px;
  font-weight: 900;
  line-height: 20px;

  @include tablet(min) {
    font-size: 16px;
    line-height: 24px;
  }
}

.preText {
  padding: 0 24px;

  @include tablet(min) {
    padding: 0 40px;
  }
}

.postText {
  padding-top: 20px;

  @include tablet(min) {
    padding-top: 40px;
  }
}

.auchanLogo {
  --color2: transparent;
  stroke: none;
  margin: -11px 0 -2px 24px;

  @include tablet(min) {
    margin-left: 40px;
  }
}
</style>
